import { Component, EventEmitter, Input, Output, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AbstractControl, FormControl, FormGroup, FormsModule } from '@angular/forms';

import { TabComponent } from './tab.component';

@Component({
  selector: 'tabs',
  template: `
  <ul *ngIf="panelVisible" class="nav nav-tabs md-pills tabs-header d-none d-md-flex text-center" role="tablist" style="background-color: #007bff;flex-direction: column;">
    <ng-container *ngFor="let tab of tabs">
      <li *ngIf="tab.visible" class="nav-item" (click)="selectTab(tab)" style="display: flex;flex-direction: column;">
        <a class="nav-link waves-light" [ngClass]="{'active': tab.active}" data-toggle="tab" href="#{{tab.name}}" role="tab" title="{{ tab.title }}"><i class="fa {{tab.glyph}} fa-lg" aria-hidden="true"></i></a>
        <span *ngIf="tab.counter" class="counter" style="margin-left: 49px;">{{tab.counter}}</span>
      </li>
    </ng-container>
  </ul>
  <div class="tab-content" [ngClass]="{'panelvisible': panelVisible}">
    <ng-content></ng-content>
  </div>
  <ul *ngIf="panelVisible" class="nav nav-tabs nav-justified d-md-none tabs-sm-header" role="tablist" style="background-color: #007bff;"> <!-- tabs-{{tabs.length}} -->
    <ng-container *ngFor="let tab of tabs">
      <li *ngIf="tab.visible" class="nav-item" (click)="selectTab(tab)">
        <a class="nav-link waves-light" [ngClass]="{'active': tab.active}" data-toggle="tab" href="#{{tab.name}}" role="tab"><i class="fa {{tab.glyph}}" aria-hidden="true"></i></a>
      </li>
    </ng-container>
  </ul>`,
  styles: [`
  .tabs-header {
      margin: 0;
      min-height: 100%;
      border-radius: 0px;
      width: 90px;
      float: left;
  }
  .tabs-sm-header {
      margin: 0;
      border-radius: 0px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
  }
  .tab-content {
      padding: 0rem 1rem 1rem 1rem;
  }
  @media (min-width: 768px) {
      .panelvisible{
          margin-left: 90px;
      }
  }
  .md-pills .nav-link {
      color: #FFF;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class TabsComponent {
  public tabs: TabComponent[] = [];
  @Input() public panelVisible: boolean = true;

  selectTab(tab: TabComponent) {
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
    tab.active = true;
  }

  addTab(tab: TabComponent) {
    if (this.tabs.length === 0) {
      tab.active = true;
    }
    this.tabs.push(tab);
  }
}
